import snukReducer from './snukReducer';

const users = (state, action) => snukReducer(state, action, 'users');

export default users;



// WEBPACK FOOTER //
// ./src/reducers/users.js